import { Event } from 'vue-tables-2';

export default {
  data() {
    return {
      lastLoadedData: [],
      requestMadeByAnUser: undefined,
      search: {
        search: '',
        type: 'opaAccountNumber',
      },

      doingSearch: false,
      status: '',
      startDate: null,
      endDate: null,

      customObject: {},

      page: 1,
      limit: 50,
      ascending: null,

    };
  },
  computed: {
    hideEdges() {
      return (Math.ceil(this.totalCount / this.tableOptions.perPage) <
        this.tableOptions.pagination.chunk);
    },
  },
  watch: {
    '$route'() {
      // This is a work around... I will need to find a way to do this better.
      if (this.allowedRoutes && !this.allowedRoutes.includes(this.$route.name)) {
        return;
      }

      console.count('watch($route)');

      this.$nextTick(() => {
        this.setFieldValues();
        console.count('getData');
        this.$refs['dashboard-table'].getData();
      });
    },
  },
  beforeMount() {
    Event.$off('vue-tables.sorted');
    Event.$off('vue-tables.pagination');

    Event.$on('vue-tables.sorted', (data) => {
      this.orderBy = data.column;
      this.ascending = data.ascending;
      this.triggerSearch();
    });
    Event.$on('vue-tables.pagination', (data) => {
      this.page = data;
      this.triggerSearch();
    });
    this.setFieldValues();
  },
  methods: {
    setFieldValues() {
      this.customObject = this.$route.query;

      if (Object.keys(this.customObject).length === 0) {
        Object.assign(this.$data, this.$options.data.apply(this));
        return;
      }

      if (this.customObject.search) {
        this.search.search = this.customObject.search;
      }
      if (this.customObject.type) {
        this.search.type = this.customObject.type;
      }
      if (this.customObject.startDate) {
        this.startDate = this.$dayjs(this.customObject.startDate).format();
        if (this.startDate === 'Invalid Date') {
          this.startDate = null;
        }
      }
      if (this.customObject.endDate) {
        this.endDate = this.$dayjs(this.customObject.endDate).format();
        if (this.endDate === 'Invalid Date') {
          this.endDate = null;
        }
      }
      if (this.customObject.status) {
        this.status = this.customObject.status;
        if (this.updateDisabledDates) {
          this.updateDisabledDates(this.customObject.status);
        }
      }

      if (this.customObject.propertyType) {
        this.propertyType = this.customObject.propertyType;
      }

      if (this.customObject.pageNumber) {
        this.tableOptions.initialPage = this.customObject.pageNumber;
      }

      if (this.customObject.orderByCol) {
        this.tableOptions.orderBy.column = this.customObject.orderByCol;
      }

      if (this.customObject.ascending) {
        this.tableOptions.orderBy.ascending = this.customObject.ascending === 'true';
      }

      if (this.customObject.caseType) {
        this.caseType = this.customObject.caseType;
      }
    },

    loaded(data) {
      this.doingSearch = false;
      this.totalCount = data.totalCount;
    },

    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$router.push({ query: {} }).catch(err => { });  // eslint-disable-line
    },

    async requestFunction(params) {
      console.log("this.requestMadeByAnUser", this.requestMadeByAnUser);
      if (this.requestMadeByAnUser === undefined || this.requestMadeByAnUser === true) {

        let query = this.$route.query;
        query.ascending = query.ascending === 'true';

        let requestObject = {
          ...params,
          ...query,
        };

        requestObject.orderByCol = query.orderByCol || params.orderBy;

        // Set status to the correct "drafts" values always here
        if (this.$route.name === 'admin-find-drafts') {
          requestObject.status = 'Draft';
        }

        this.requestMadeByAnUser = false;
        this.lastLoadedData = await this.$store.dispatch(this.searchAction, requestObject);
        return this.lastLoadedData;
      }
      this.requestMadeByAnUser = false;
      return this.lastLoadedData;
    },
    responseAdapter(data) {
      this.doingSearch = true;
      const resp = { data: [], count: 0 };
      if (typeof data === "object" && data.totalCount) {
        resp.data = data[this.returnFromSearchParam];
        resp.count = data.totalCount;

        if (data.pageNumber > data.totalPages) {
          resp.data = [];
          resp.count = 0;
          this.page = 1;
          this.triggerSearch();
        }
      }

      return resp;
    },
    async triggerSearch() {
      console.count("triggerSearch");

      let startDate = this.$dayjs(this.startDate).format('YYYY-MM-DD');
      let endDate = this.$dayjs(this.endDate).format('YYYY-MM-DD');

      this.customObject = {
        ...this.customObject,
        ...{
          opaAccountNumber: undefined,
          zipCode: undefined,
          startDate: startDate !== 'Invalid Date' ? startDate : undefined,
          endDate: endDate !== 'Invalid Date' ? endDate : undefined,
          status: this.status || undefined,
          pageNumber: parseInt(this.page),
          pageSize: parseInt(this.limit),
          orderByCol: this.orderBy,
          ascending: this.ascending ? true : false,
          type: this.search.type,
          search: !this.search.search ? undefined : this.search.search,
          propertyType: !this.propertyType ? undefined : this.propertyType,
          caseType: !this.caseType ? undefined : this.caseType,
        },
      };

      Object.keys(this.searchTypes).forEach(element => this.customObject[element] = undefined);

      if (this.search.type === 'opaAccountNumber' && !!this.search.search) {
        this.customObject[this.search.type] = await this.$store.dispatch('properties/getOPAAccountNumbers', this.search.search);
      } else if (this.search.search) {
        this.customObject[this.search.type] = this.search.search;
      }

      this.requestMadeByAnUser = true;
      this.$router.push({ query: this.customObject }).catch(err => { });  // eslint-disable-line
    },

    clearSearchTable() {
      this.search.search = '';
      this.search.type = 'opaAccountNumber';
      this.reset();
    },
  },
};